<template>
  <div>
    <Dialog
      ref="dialog"
      :title="dialogTitle"
      icon="icon-cy-idxDeail"
      :is-show-footer="true"
      width="796px"
      @dialogSure="dialogSure"
    >
      <el-form
        @submit.native.prevent
        :model="userForm"
        :rules="userFormRules"
        ref="userForm"
        label-width="84px"
      >
        <el-form-item
          label="角色名称："
          prop="name"
        >
          <el-input
            maxlength="10"
            v-model.trim="userForm.name"
            placeholder="请输入角色名称（不超过10个字）"
          />
        </el-form-item>
        <el-form-item
          label="角色类型："
          prop="roleType"
          v-if="setting_role_open"
        >
          <el-select
            v-model="userForm.roleType"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in roleTypeSelect"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="授权范围："
          prop="scope"
          class="is-required"
        >
          <div class="auth-select">
            <button
              :class="currentAuthSelect === 'menu' ? 'btn-active' : ''"
              @click="changeAuthSelect('menu')"
            >
              菜单权限
            </button>
            <button
              :class="currentAuthSelect === 'menu' ? '' : 'btn-active'"
              @click="changeAuthSelect('operation')"
            >
              操作权限
            </button>
          </div>
          <div class="auth-container">
            <div
              class="menu-list"
              v-if="currentAuthSelect === 'menu'"
            >
              <div class="hd">
                <span>一级菜单</span>
                <span>二级菜单</span>
              </div>
              <div class="bd">
                <div
                  class="item"
                  v-for="(item, index) in menuData"
                  :key="index"
                >
                  <el-checkbox
                    class="item-menu first-menu"
                    :label="item.id"
                    v-model="checkFirstMenu[index]"
                    @change="checkAllMenu($event, index)"
                  >
                    {{ item.name }}
                  </el-checkbox>
                  <el-checkbox-group
                    class="item-menu seconed-menu"
                    v-model="checkedMenu[index]"
                    @change="handleCheckedMenuChange($event, index)"
                  >
                    <el-checkbox
                      v-for="(subItem, subIndex) in item.children"
                      :key="subIndex"
                      :label="subItem.id"
                      :class="{ highlight: subItem.type === 2 }"
                    >
                      {{ subItem.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
            <div
              class="operation-list"
              v-if="currentAuthSelect === 'operation'"
            >
              <div class="left-bar">
                <el-tree
                  accordion
                  :data="roleMenu"
                  :props="defaultProps"
                  @node-click="handleNodeClick"
                >
                  <div slot-scope="scope">
                    <slot
                      :node="scope.node"
                      :data="scope.data"
                    >
                      <template>
                        <span
                          :title="scope.data.label"
                          class="el-tree-node__label"
                        >{{ scope.data.name }}</span>
                      </template>
                    </slot>
                  </div>
                </el-tree>
              </div>
              <div class="right-content">
                <ul>
                  <li
                    v-for="(group, index) in myRoleOperation"
                    :key="'group' + index"
                  >
                    <el-checkbox
                      class="select-all"
                      :indeterminate="group.isIndeterminate"
                      v-model="group.isCheckedAll"
                      @change="handleCheckAllChange($event, index)"
                    >
                      {{ group.name }}
                    </el-checkbox>
                    <el-checkbox-group
                      v-model="group.checkedOperation"
                      @change="handleCheckedChange($event, index)"
                    >
                      <el-checkbox
                        v-for="operationItem in group.operationArr"
                        :label="operationItem.name"
                        :key="operationItem.name"
                      >
                        {{ operationItem.name }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </Dialog>
    <Dialog
      ref="addRoleTipsDialog"
      class="addRoleTipsDialog"
      :is-show-footer="false"
      width="450px"
    >
      <div class="delete-text">
        请选择授权范围
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from './dialog'
export default {
  props: {
    isAlter: {
      type: Boolean,
      default: false
    },
    menuData: {
      type: Array,
      default: () => []
    },
    menuList: {
      type: Array,
      default: () => []
    },
    defaultProps: {
      type: Object,
      default: () => {}
    },
    roleOperation: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Dialog
  },
  computed: {
    dialogTitle() {
      return `${this.isAlter ? '修改' : '新增'}角色`
    },
    menuLen() {
      return this.menuData.length
    },
    roleMenu() {
      return this.isAlter ? this.menuList : this.menuData
    },
    myRoleOperation() {
      return this.roleOperation
    },
    roleTypeSelect() {
      let arr = []
      if (setting_role_open) {
        arr = [
          { label: '自定义', value: 3 },
          { label: '媒体管理员', value: 1 },
          { label: '媒体普通用户', value: 2 }
        ]
      } else {
        arr = [
          { label: '自定义', value: 3 }
        ]
      }
      return arr
    }
  },
  data() {
    return {
      setting_role_open: setting_role_open,
      userForm: {
        id: 0,
        name: '',
        roleType: 1
      },
      userFormRules: {
        name: [
          { required: true, message: '请输入角色名', trigger: 'blur' },
          { max: 10, message: '不能超过10个字', trigger: 'blur' }
        ],
        roleType: [{ required: true, message: '请选择角色类型', trigger: 'blur' }]
      },
      test: false,
      checkedMenu: [],
      checkFirstMenu: [],
      // operation auth
      currentAuthSelect: 'menu'
    }
  },
  methods: {
    // 初始菜单状态填充
    initCheck() {
      this.checkedMenu = new Array(this.menuLen).fill([])
      this.checkFirstMenu = new Array(this.menuLen).fill(false)
      this.checkedMenu.forEach((item, index) => {
        let selectedItem = this.menuData[index].children.filter(
          menuItem => menuItem.selected
        )
        this.$set(
          this.checkedMenu,
          index,
          selectedItem.map(i => i.id)
        )
      })
      this.checkFirstMenu.forEach((item, index) => {
        this.$set(
          this.checkFirstMenu,
          index,
          this.checkedMenu[index].length ===
            this.menuData[index].children.length
        )
      })
    },
    // 一级菜单选中状态更改=>更新二级菜单选中
    checkAllMenu(value, index) {
      this.checkedMenu[index] = value
        ? this.menuData[index].children.map(item => item.id)
        : []
    },
    // 二级菜单选中状态更改=>更新一级菜单状态
    handleCheckedMenuChange(value, index) {
      this.$set(
        this.checkFirstMenu,
        index,
        value.length === this.menuData[index].children.length
      )
    },
    initParmas(userInfo) {
      if (
        document.querySelector('.el-dialog.cy-dialog-common .menu-list .bd')
      ) {
        document.querySelector(
          '.el-dialog.cy-dialog-common .menu-list .bd'
        ).scrollTop = 0
      }
      if (this.$refs.userForm) {
        this.$refs.userForm.resetFields()
      }
      this.userForm = {
        id: userInfo.id || 0,
        name: userInfo.name || '',
        roleType: userInfo.roleType || 3
      }
    },
    changeAuthSelect(val) {
      this.currentAuthSelect = val
    },
    // tree 点击某个菜单
    handleNodeClick(data) {
      this.$emit('getRoleMenusOperations', data.id)
    },
    handleCheckAllChange(val, index) {
      this.myRoleOperation[index].checkedOperation = []
      if (val) {
        this.myRoleOperation[index].operationArr.forEach(item => {
          this.myRoleOperation[index].checkedOperation.push(item.name)
        })
      }
      this.myRoleOperation[index].isIndeterminate = false
    },
    handleCheckedChange(value, index) {
      this.myRoleOperation.checkedOperation = value
      let checkedCount = value.length
      this.myRoleOperation[index].isCheckedAll = checkedCount === this.myRoleOperation[index].operationArr.length
      this.myRoleOperation[index].isIndeterminate = checkedCount > 0 && checkedCount < this.myRoleOperation[index].operationArr.length
    },
    dialogSure() {
      this.$refs.userForm.validate(valid => {
        if (valid) {
          let result = this.checkedMenu.filter(item => item.length !== 0)
          if (result.length === 0) {
            this.$refs.addRoleTipsDialog.cyDialogCommon = true
            return false
          }
          // 格式化roleOperation
          let arr = []
          // 循环每一个分组

          console.log(arr)
          this.$emit('dialogSure', result.join(',').split(','))
        }
      })
    }

  },
  watch: {
    menuData: {
      handler(newVal, oldVal) {
        if (newVal.length !== 0) {
          this.initCheck()
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog.cy-dialog-common {
  .el-dialog__header {
    padding: 28px 30px;
  }
  .el-dialog__body {
    padding: 0 61px 0 30px;
    .el-form {
      width: 100%;
      &-item {
        margin-bottom: 20px;
        &__label {
          padding: 0;
          line-height: 30px;
        }
        &__content {
          line-height: 30px;
          .el-input__inner {
            height: 30px;
            background: #fff;
            border-radius: 5px;
            // font-family: "founder_youhei_508R";
          }
          .menu-list {
            padding-bottom: 30px;
            .hd {
              display: flex;
              background: #f5f5f5;
              border: 1px solid #e5e5e5;
              color: #333;
              span {
                height: 42px;
                padding-left: 20px;
                line-height: 42px;
                color: #333;
                border-left: 1px solid #e5e5e5;
                &:first-child {
                  width: 125px;
                  border: none;
                }
              }
            }
            .bd {
              max-height: calc(100vh - 349px);
              overflow: auto;
              border: 1px solid #e5e5e5;
              border-width: 0 1px 1px;
              /deep/ .el-checkbox__label {
                padding-left: 10px;
              }
              .item {
                display: flex;
                align-items: center;
                border-bottom: 1px solid #e5e5e5;
                .item-menu {
                  padding-left: 20px;
                  &:first-child {
                    width: 125px;
                    flex-shrink: 0;
                  }
                  &.seconed-menu {
                    min-height: 31px;
                    padding: 8px 0 5px 20px;
                    border-left: 1px solid #e5e5e5;
                    .el-checkbox {
                      margin: 0 20px 0 0;
                      &.highlight {
                        .el-checkbox__inner {
                          border-color: #ffc272;
                        }
                        .el-checkbox__label {
                          color: #ffa85b;
                        }
                        &.is-checked {
                          .el-checkbox__inner{
                             border-color: #FD9B1C;
                            background-color: #FD9B1C;
                          }
                          .el-checkbox__label {
                            color:#FD8C1D;
                          }
                        }
                      }
                    }
                  }
                }
                &:last-child{
                  border:none;
                }
              }
            }
          }
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
/deep/ .addRoleTipsDialog .el-dialog.cy-dialog-common{
 .el-dialog__body{
   padding:0 30px 30px;
 }
}
.auth-select {
  button {
    width: 80px;
    height: 30px;
    background: #FFFFFF;
    border: 1px solid #DBDBDB;
    border-radius: 5px;
    color: #666;
    margin-right: 10px;
    outline: none;
    cursor: pointer;
    margin-bottom: 12px;
  }
  .btn-active {
    background: #4497EC;
    color: #fff;
    border-color: #4497EC;
  }
}
.operation-list {
  width: 790px;
  position: relative;
  left: -113px;
  border-top: 1px solid #E8E8E8;
  display: flex;
  justify-content: left;
  .left-bar {
    width: 170px;
    border-right: 1px solid #E8E8E8;
    height: calc(100vh - 349px);
    overflow-y: auto;
  }
  .el-tree {
    color: #333333;
    background: #fff;
    /deep/ .el-tree-node.is-current.is-focusable { // 选中状态样式
      >.el-tree-node__content {
        color: #fff;
        background: #649CF7;
      }
    }
    /deep/ .el-tree-node__content {
      height: 42px;
      border-bottom: 0;
      // &:hover {
      //   background-color: #649CF7;
      //   color: #fff;
      // }
      .el-tree-node__expand-icon {
          margin-left: 0;
        }
      .el-tree-node__label {
        font-size: 14px;
        max-width: 100px;
        display: inline-block;
        vertical-align: middle;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .right-content {
    padding: 14px 16px;
    width: 100%;
    li {
      line-height: 30px;
      padding: 5px 0;
      border-bottom: 1px solid #F5F5F5;
    }
    .select-all {
      color: #4497ec;
    }
    /deep/ .el-checkbox-group {
      display: inline-block;
      vertical-align: middle;
      margin-left: 40px;
      .el-checkbox+.el-checkbox {
        margin-left: 18px;
      }
      .el-checkbox__input.is-checked+.el-checkbox__label {
        color: #454647;
      }
    }
  }
}
</style>
